import React, { useEffect,useState } from "react";
import Api from '../../../api/global.service';
import ApiUrl from '../../../constants/Api';
import DataTable from 'react-data-table-component';
import Swal from "sweetalert2";
import DeleteButton from '../../../nuup/componentes/Generales/DeleteButton';
import estiloGeneral from '../../../nuup/componentes/Tablas/estiloGeneral';
import { Link } from "react-router-dom";
import  '../../../nuup/styles/Tablas.css'
import LecturasTensiometrosExportar from './LecturasTensiometrosExportar';
import BlockUi from 'react-block-ui';
import HerramientasTablas from '../../../nuup/componentes/Tablas/HerramientasTablas/HerramientasTablas';
import Button from 'react-bootstrap/Button';

var dataArray = [];
const LecturasTensiometrosTabla = (props) => {
	const [datosFiltrados, setDatosFiltrados] = useState([]);
	const [blocking, setBlocking] = useState(false);
	const [columns, setColumns] = useState([
		{
			name: 'ID',
			selector: 'id_sector_lectura_tensiometro',
			maxWidth: '100px',
			sortable: true,
			right: false
		},
		{
			name: 'Productor',
			selector: 'productor_nombres',
			sortable: true,
			right: false
		},
		{
			name: 'Huerta',
			selector: 'nombre_huerta',
			sortable: true,
			right: false
		},
		{
			name: 'Evento',
			selector: 'evento',
			sortable: true,
			right: false
		},
		{
			name: 'Fecha Lectura',
			selector: 'fecha_lectura',
			sortable: true,
			right: false
		},
		{
			name: 'Exceso Humedad',
			selector: 'exceso_humedad',
			sortable: true,
			right: false
		},
		{
			name: 'Máximo suelo seco',
			selector: 'max_suelo_seco',
			sortable: true,
			right: false
		},
		{
			name: 'Valor',
			selector: 'valor',
			sortable: true,
			right: false
		},
		{
			name: 'OPCIONES',
			button: true,
			cell: (row) => <><Button className="btn btn-xs btn-warning" onClick={() => onUpdateClick(row.id_sector_lectura_tensiometro)}><i className="fa fa-edit"></i></Button> <DeleteButton onClick={() => eliminaRegistro(row.id_sector_lectura_tensiometro)}><i className="fa fa-trash"></i></DeleteButton></>,
		}
	]);


	useEffect(() => {
		if(props.id_productor > 0){setColumns(columns.filter(function(item){ return item['selector'] !== 'productor_nombres' }))}
		obtenerRegistros(props.id_productor);
	}, [props.id_productor,props.reload]);

	  const obtenerRegistros = (id_productor = 0)  => {
		setBlocking(true);
		Api.getAll(ApiUrl.riegos.lecturasTensiometros.general + '?id_productor=' + id_productor)
		  .then(response => {
			  dataArray = response.data.data; 
			  setBlocking(false);
			  setDatosFiltrados(response.data.data);
			console.log(response.data.data);
		  })
		  .catch(e => {
			setBlocking(false);
			console.log(e);
		  });
	  }


	const eliminaRegistro = (id_sector_lectura_tensiometro) => {		
		Swal.fire({
			title: '¿Esta seguro?',
			text: "El registro se eliminará",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Si, eliminar!'
		  }).then((result) => {
			if (result.isConfirmed) {
				setBlocking(true);
				Api.delete(ApiUrl.riegos.lecturasTensiometros.general, id_sector_lectura_tensiometro)
				.then(response => {
					let _result = response.data;
					if(_result.success === 1){
						setBlocking(false);
						Swal.fire(
						  'Eliminado!',
						  'Registro eliminado.',
						  'success'
						);
					}
				obtenerRegistros();
				})
				.catch(e => {
					setBlocking(false);
				  Swal.fire(
					'Error!',
					'Error al eliminar el registro.',
					'error'
				  );
				  obtenerRegistros();
				});

			}
		  })

	};
	const handleChange = (datosFiltrados) => {setDatosFiltrados(datosFiltrados);}
	const onUpdateClick = (id_sector_lectura_tensiometro) => {props.onUpdateClick(id_sector_lectura_tensiometro);}

	return (
		<BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
			<HerramientasTablas 
				txtBusqueda="Buscar lectura" 
				datosTabla={dataArray} 
				urlRegistrar={false} 
				columnasFiltrar={["productor_nombres","nombre_sector","created_at"]}
				exportar={false}
				onFiltrar={(datosFiltrados) => handleChange(datosFiltrados)}
			/>
          <DataTable
		  	noHeader
            pagination
            columns={columns}
            data={datosFiltrados}
            Clicked
			noDataComponent={'Sin datos por mostrar'}
			customStyles={estiloGeneral}
          />
		</BlockUi>
    );
  };
export default LecturasTensiometrosTabla;
